var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokDesktopChevronEast = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 14,
  viewBox: "0 0 8 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M5.748 6.8.11 12.422a.38.38 0 0 0 0 .534l.533.536a.38.38 0 0 0 .534 0l6.12-6.101a.83.83 0 0 0 0-1.178L1.178.11a.38.38 0 0 0-.534.001L.11.646a.38.38 0 0 0 .001.534z"
})));
export default SvgTiktokDesktopChevronEast;